/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class CalendarEvents {

  uuid: string | undefined = undefined;

  title: string | undefined = undefined;

  description: string | undefined = undefined;

  color: string | undefined = undefined;

  end: string | undefined = undefined;

  start: string | undefined = undefined;

  constructor(uuid: string, title: string, description: string, color: string, end: string, start: string) {
    this.uuid = uuid;
    this.title = title;
    this.description = description;
    this.color = color;
    this.end = end;
    this.start = start;
  }
}
